import React from "react";
import { useAuthContext } from "../../../contexts/AuthContext";
import Loader from "../../UI/Loader";
import PostPlannerApp from "./PostPlannerApp";

const PostPlanner = () => {
  const context = useAuthContext();

  // Wait for auth context to be ready
  if (!context?.ready) return <Loader />;

  // Render the main Post Planner app
  return <PostPlannerApp />;
};

export default PostPlanner;
